import { Injectable } from '@angular/core';

@Injectable()
export class imageUtil {
  getGenderImage(genderCd) {
    switch (genderCd) {
      case "MALE":
        return "assets/images/ico/male.png";
      case "FEMALE":
        return "assets/images/ico/female.png";
      default:
        return "assets/images/ico/person.png";
    }
  }
}